import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import {translate} from '@jsverse/transloco';
import { UrlService } from 'src/app/services/util/url.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { Constants } from 'src/app/models/constants';
import { ClipboardService } from 'ngx-clipboard';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import cloneDeep from 'lodash/cloneDeep';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
@Component({
    selector: 'app-instance-details-add-route',
    templateUrl: './instance-details-add-route.component.html',
    styleUrls: ['./instance-details-add-route.component.scss'],
    standalone: false
})
export class InstanceDetailsAddRouteComponent  implements OnInit {
  @Input() id;
  @Input() editData;
  @Input() edit;
  @Input() sftpEncKeyRotation;
  @Input() isArtifactoryFeature = false;
  private destroyRef = inject(DestroyRef);
  loggedData: any;
  routeForm: FormGroup;
  Constants = Constants;
  encEnabledData: boolean;
  encryptionKeyEnable: boolean;
  encryptionKeys: any;
  selectedKey: any;
  hide: boolean;
  copyEnd = false;
  copyName = false;
  showLoader = false;
  searchKeyValue: string = '';
  filteredEncryptionKeys: any[] = [];
  isFormChanged = false;
  originalEditData: any;
  // eslint-disable-next-line max-len
  dataLink = 'https://learn.microsoft.com/en-us/azure/storage/common/storage-account-get-info?tabs=portal#get-the-resource-id-for-a-storage-account';

  constructor(private fb: FormBuilder, private toastrService: ToastrService,
    private sidenavService: SidenavService, private dialog: MatDialog, private instanceService: InstancesService, private clipboardApi: ClipboardService, private customToastrService: CustomToastrService) {

 }

 ngOnInit(): void {
  this.initializeForm();
 }

 private initializeForm(): void {
  if(this.loggedData) {
    this.encEnabledData = this.loggedData.encEnabled;
    if(this.encEnabledData === true) {
      this.encryptionKeyEnable = true;
    } else {
      this.encryptionKeyEnable = false;
    }
    let formConfig: any;
    if(this.sftpEncKeyRotation) {
    formConfig = {
      routeName: ['', [Validators.required]],
      direction: [this.loggedData.direction,[Validators.required]],
      sourcePath: ['', [Validators.required]],
      componentStorage: ['', [Validators.required]],
      componentFileShare: ['', [Validators.required]],
      componentFilePath: ['', [Validators.required]],
      encEnabled: '',
      encKey: '',
      encKeyName: '',
      destinationType: [this.loggedData.destinationType,[Validators.required]],
      ciProvider: '',
      projectName: '',
      branch: '',
      ciTriggerEnabled: ''
     };
    } else {
      formConfig = {
        routeName: ['', [Validators.required]],
        direction: [this.loggedData.direction,[Validators.required]],
        sourcePath: ['', [Validators.required]],
        componentStorage: ['', [Validators.required]],
        componentFileShare: ['', [Validators.required]],
        componentFilePath: ['', [Validators.required]],
        encEnabled: '',
        encKey: '',
        destinationType: [this.loggedData.destinationType,[Validators.required]],
        ciProvider: '',
        projectName: '',
        branch: '',
        ciTriggerEnabled: ''
      };
    }
     this.routeForm = this.fb.group(formConfig);
  } else {
    this.encEnabledData = false;
    this.encryptionKeyEnable = false;
    let formConfig: any;
    if(this.sftpEncKeyRotation) {
      formConfig = {
        routeName: ['', [Validators.required,Validators.pattern('^[A-Za-z0-9]*$')]],
        direction: ['inbound',[Validators.required]],
        componentStorage: '',
        componentFileShare: '',
        componentFilePath: ['', [Validators.required]],
        encEnabled:'',
        encKey:'',
        encKeyName: '',
        destinationType: ['fileshare',[Validators.required]],
        ciProvider: '',
        projectName: '',
        branch: '',
        ciTriggerEnabled: false
      };
      } else {
    formConfig = {
      routeName: ['', [Validators.required,Validators.pattern('^[A-Za-z0-9]*$')]],
      direction: ['inbound',[Validators.required]],
      componentStorage: '',
      componentFileShare: '',
      componentFilePath: ['', [Validators.required]],
      encEnabled:'',
      encKey:'',
      destinationType: [this.isArtifactoryFeature ? 'artifactory' : 'fileshare',[Validators.required]],
      ciProvider: '',
      projectName: '',
      branch: '',
      ciTriggerEnabled: false
     };
    }
     this.routeForm = this.fb.group(formConfig);
  }
  this.updateMandatoryFields();
  this.hide = true;
  this.getEncKeys();
  this.filteredEncryptionKeys = this.encryptionKeys || [];
  if(this.editData) {
    this.editData.ciTriggerEnabled = this.editData.ciTriggerEnabled === true || this.editData.ciTriggerEnabled === 'true';
    this.routeForm.patchValue({
      ...this.editData,
      ciProvider: this.editData.ciTriggerConfig?.ciProvider ?? '',
      projectName: this.editData.ciTriggerConfig?.projectName ?? '',
      branch: this.editData.ciTriggerConfig?.branch ?? ''
    });
    Object.keys(this.routeForm.controls).forEach(field => {
      this.routeForm.get(field)?.disable();
    });
    this.routeForm.get('encEnabled')?.enable();
    this.encEnabledData = this.routeForm.get('encEnabled').value === 'true' ? true : false;
    if(this.encEnabledData === true) {
      this.encryptionKeyEnable = true;
      this.routeForm.get('encKeyName')?.enable();
    } else {
      this.routeForm.get('encEnabled').setValue(false);
      this.encryptionKeyEnable = false;
    }
    this.originalEditData = cloneDeep({
      encEnabled: this.routeForm.get('encEnabled')?.value,
      encKeyName: this.routeForm.get('encKeyName')?.value
    });
    this.checkSelection();
    this.routeForm.get('encEnabled')?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkSelection());

    this.routeForm.get('encKeyName')?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkSelection());
  }
 }
 // update required fields based on destinationType
  updateMandatoryFields () {
    this.routeForm.get('destinationType')?.valueChanges.subscribe((type) => {
      const componentStorage = this.routeForm.get('componentStorage');
      const componentFileShare = this.routeForm.get('componentFileShare');
      const branch = this.routeForm.get('branch');
      const ciProvider = this.routeForm.get('ciProvider');
      const projectName = this.routeForm.get('projectName');

      if (type === 'fileshare') {
        // Clear Artifactory fields
        this.routeForm.patchValue({ ciProvider: '', projectName: '', branch: '', ciTriggerEnabled: false});
        componentStorage?.setValidators([Validators.required]);
        componentFileShare?.setValidators([Validators.required]);
        branch?.clearValidators();
        ciProvider?.clearValidators();
        projectName?.clearValidators();
      } else {
        // Clear Fileshare fields
        this.routeForm.patchValue({ componentStorage: '', componentFileShare: '',  encEnabled: false, encKey: '', encKeyName: ''});
        componentStorage?.clearValidators();
        componentFileShare?.clearValidators();
      }

      componentStorage?.updateValueAndValidity();
      componentFileShare?.updateValueAndValidity();
      branch?.updateValueAndValidity();
      ciProvider?.updateValueAndValidity();
      projectName?.updateValueAndValidity();
    });
  }

  checkSelection(): void {
    const currentData = {
      encEnabled: this.routeForm.get('encEnabled')?.value,
      encKeyName: this.routeForm.get('encKeyName')?.value?.name || this.routeForm.get('encKeyName')?.value || ''
    };
    const originalData = {
      encEnabled: this.originalEditData.encEnabled,
      encKeyName: this.originalEditData.encKeyName?.name || this.originalEditData.encKeyName || ''
    };
    this.isFormChanged = JSON.stringify(originalData) !== JSON.stringify(currentData);
  }

  onSubmit(): void {
    this.updateEncKeyNameValidation();
    if(!FormUtilService.validateForm(this.routeForm)) {
      return;
    }
    const { branch, ciProvider, projectName, ciTriggerEnabled, componentStorage, componentFileShare, encEnabled, encKey, encKeyName, ...rest} = this.routeForm.getRawValue();
    const data = {...rest};
    if (data.destinationType === 'artifactory') {
      data.ciTriggerEnabled = ciTriggerEnabled === true || ciTriggerEnabled === 'true';
      data.ciTriggerConfig = {ciProvider, projectName, branch};
    } else {
      data.componentStorage = componentStorage;
      data.componentFileShare = componentFileShare;
      data.encEnabled = encEnabled === true || encEnabled === 'true';
      if(data.encEnabled === true || data.encEnabled === 'true') {
        data.encKey = encKey;
        data.encKeyName = encKeyName?.name;
      } else {
        data.encEnabled = false;
        data.encKey = '';
        data.encKeyName = "";
      }
    }  
   data.id = this.id;
   if(!this.editData) {
    this.createRoute(data);
   } else {
    this.editRoute(data);
   }
  }

 /* It Opens a confirmation dialog to edit a SFTP route.
  If the user confirms, On success, closes the side navigation with the API response*/
  private editRoute(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.EDIT_ROUTE_TITLE'),
        message: translate('INSTANCE_DETAILS.EDIT_ROUTE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.showLoader = true;
          const routeData = {
            id: this.id,
            routeId: this.editData.routeId,
            encEnabled: data.encEnabled === true || data.encEnabled === 'true',
            encKeyName: (data.encEnabled === true || data.encEnabled === 'true') ? data.encKeyName : ''
          }
          this.instanceService.putInstanceDetailsSftpDetailsByIdByRouteID(routeData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.showLoader = false;
              this.sidenavService.closeRightSidenav(response);
              setTimeout(() => {
              const title = translate('INSTANCE_STATUS.ROUTE');
              const message = translate('INSTANCE_STATUS.EDIT_ROUTE_KEY');
              this.customToastrService.successMessage(message, title);
            }, 500);
            }, (error) => {
              this.showLoader = false;
              const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('ERROR_DIALOG.ADD_ROUTE_NOT_AVAILABLE'),
                  description: errorMessage
                }
              });
            })
        }
      })
  }

 cancel(): void {
   this.routeForm.reset();
 }

 closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
 }

 hideShowFunction(): void {
  this.hide = !this.hide;
}

  encEnabled(event): void {
    this.encEnabledData = event.checked;
    if (this.encEnabledData === true) {
      this.encryptionKeyEnable = true;
    } else {
      this.encryptionKeyEnable = false;
      this.selectedKey = null;
    }
    this.updateEncKeyNameValidation();
  }

  updateEncKeyNameValidation(): void {
    const encKeyControl = this.routeForm.get('encKeyName');
    if (this.encEnabledData) {
      encKeyControl?.enable();
      encKeyControl?.setValidators([Validators.required]);
    } else {
      encKeyControl?.clearValidators();
      encKeyControl?.setValue('');
      encKeyControl?.disable();
    }
    encKeyControl?.updateValueAndValidity();
  }

openUrl(data): void {
  const url = `https://portal.azure.com/#@temenosgroup.onmicrosoft.com/resource${data}`;
  window.open(url, '_blank');
}

onCopyEndPoint(data): void {
  this.copyEnd = true;
  this.clipboardApi.copyFromContent(data);
  setTimeout(() => {
    this.copyEnd = false;
  }, 500);
}

onCopyUserName(data): void {
  this.copyName = true;
  this.clipboardApi.copyFromContent(data);
  setTimeout(() => {
    this.copyName = false;
  }, 500);
}

  /*get call method for Encryption Keys*/
  getEncKeys(): void {
    this.instanceService.getEncryptionKeys(this.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (keysResponse: any[]) => {
          this.encryptionKeys = keysResponse.map(key => ({
            ...key,
            expirationDate: key.expirationDate?.replace(/"/g, '')
          }));
          this.encryptionKeys = this.encryptionKeys.filter((item) => {return new Date(item.expirationDate.trim()) > new Date()})
          if(this.routeForm.get('encKeyName')?.value) {
            const data = this.encryptionKeys.find(item => item.name === this.routeForm.get('encKeyName')?.value);
            !data ? this.routeForm.get('encKeyName')?.enable() :'';
            this.selectionChanged(data);
          }
          this.filteredEncryptionKeys = [...this.encryptionKeys];
        },
        error: (error) => {
          console.error('Failed to fetch encryption keys:', error);
          this.encryptionKeys = [];
          this.filteredEncryptionKeys = [];
        }
      });
  }

  selectionChanged(selected: any): void {
    this.selectedKey = selected;
    this.routeForm.patchValue({ encKeyName: selected });
  }

  searchKeyChanged(searchTerm: string): void {
    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredEncryptionKeys = [...this.encryptionKeys];
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      this.filteredEncryptionKeys = this.encryptionKeys.filter(key =>
        key.name.toLowerCase().includes(lowerSearch)
      );
    }
    // If search term does not match any key, clear selection
    if (this.filteredEncryptionKeys.length === 0) {
      this.selectedKey = null;
      this.routeForm.get('encKeyName')?.setValue('');
    }
  }

  // When dropdown opens, always clear the search and reset full data
  onDropdownOpen(): void {
    this.searchKeyValue = '';
    this.filteredEncryptionKeys = [...this.encryptionKeys];

  }

  /* It Opens a confirmation dialog to create a new SFTP route.
  If the user confirms, On success, closes the side navigation with the API response*/
  private createRoute(routeData): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.ADD_ROUTE_TITLE'),
        message: translate('INSTANCE_DETAILS.ADD_ROUTE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.showLoader = true;
          //data.id = this.id;
          this.instanceService.postInstanceDetailsSftpDetailsById(routeData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.showLoader = false;
              this.sidenavService.closeRightSidenav(response);
              setTimeout(() => {
              const title = translate('INSTANCE_STATUS.ROUTE');
              const message = translate('INSTANCE_STATUS.ADD_ROUTE_KEY');
              this.customToastrService.successMessage(message, title);
            }, 500);
            }, (error) => {
              this.showLoader = false;
              const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('ERROR_DIALOG.ADD_ROUTE_NOT_AVAILABLE'),
                  description: errorMessage
                }
              });
            })
        }
      })
  }
 get formControls(): any {
   return this.routeForm.controls;
 }



}

